// One message system for the whole admin panel: toast("Saved") or toast("Could not save", "error").
// <Toaster /> (mounted once in App.js) shows them at the top of the screen, where they are visible on phones too.
// tone: 'ok' (green, success), 'warn' (amber, check something), 'error' (red, it failed)
export const TOAST_EVENT = "oz:toast";

export function toast(text, tone = "ok") {
  if (!text) return;
  window.dispatchEvent(new CustomEvent(TOAST_EVENT, { detail: { text, tone } }));
}
